/**
 * Normalize a slug to a standard format that can be used for comparison
 *
 * Only compare against other normalized slugs.
 */
export function normalizeSlug(params: { slug: string }): string {
  return params.slug.toLowerCase().trim();
}
